"use client";

import { useEffect } from "react";
import { reportBootstrapError } from "@/data/telemetry";

/**
 * Rendered by Next.js when the root layout itself fails — the app couldn't start, so none of its
 * own error handling is available. Reports the failure as a `BootstrapError` (PAT1-16082).
 */
export default function GlobalError(props: { error: Error & { digest?: string }; reset: () => void }) {
  const { error } = props;

  useEffect(() => {
    reportBootstrapError(error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ fontFamily: "sans-serif", padding: "2rem" }}>
        <h2>Something went wrong</h2>
        <p>Pattern could not start. Please reload the page, and contact support if this keeps happening.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload
        </button>
      </body>
    </html>
  );
}
